import { FC } from 'react';
import { Text } from '@servicetitan/anvil2';

import { MessageCard } from '../../message-card/message-card';
import { EquipmentItemModel } from '../../../models/equipment.model';
import { formatDate } from '../../../utils/format-date';

interface EquipmentDetailProps {
    data: EquipmentItemModel;
}

export const EquipmentDetail: FC<EquipmentDetailProps> = ({ data }) => {
    return (
        <MessageCard flexDirection="column">
            <div className="m-b-1">
                <Text variant="eyebrow" className="m-b-half" size="small">
                    Name
                </Text>
                <Text size="small">{data.name}</Text>
            </div>

            <div className="m-b-1">
                <Text variant="eyebrow" className="m-b-half" size="small">
                    Manufacturer
                </Text>
                <Text size="small">{data.manufacturer}</Text>
            </div>

            <div className="m-b-1">
                <Text variant="eyebrow" className="m-b-half" size="small">
                    Model Number
                </Text>
                <Text size="small">{data.model_number}</Text>
            </div>

            <div className="m-b-1">
                <Text variant="eyebrow" className="m-b-half" size="small">
                    Serial Number
                </Text>
                <Text size="small">{data.serial_number}</Text>
            </div>

            <div className="m-b-1">
                <Text variant="eyebrow" className="m-b-half" size="small">
                    Installation Date
                </Text>
                <Text size="small">{formatDate(new Date(data.installation_date))}</Text>
            </div>

            <div className="m-b-1">
                <Text variant="eyebrow" className="m-b-half" size="small">
                    Type
                </Text>
                <Text size="small">{data.type || '--'}</Text>
            </div>

            <div>
                <Text variant="eyebrow" className="m-b-half" size="small">
                    Memo
                </Text>
                <Text size="small">{data.memo}</Text>
            </div>

            {/* <BodyText className="m-b-half" bold size="small">
                Tags
            </BodyText>
            {data.tags.length ? (
                <Stack>
                    {data.tags.map(tag => {
                        return <Chip label={tag.name} color={tag.color} key={tag.name} />;
                    })}
                </Stack>
            ) : (
                <BodyText className="m-b-half" size="small">
                    --
                </BodyText>
            )} */}
        </MessageCard>
    );
};
